import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSupportContext } from "../hooks/useSupportContext";
import { isStaging } from "./StagingBanner";

const HEIGHT = 36;

/**
 * Fixed amber bar shown while a staff member works inside a customer
 * organization. Sits under the staging bar when both are visible. Everything a
 * staff member saves while this bar is visible lands on the customer's account
 * and is written to support_audit_log on the server.
 */
export default function SupportContextBanner() {
  const { activeOrg, leave } = useSupportContext();
  const navigate = useNavigate();
  const top = isStaging() ? 30 : 0;

  useEffect(() => {
    if (!activeOrg) return undefined;
    const prev = document.body.style.paddingTop;
    const base = parseInt(prev || "0", 10) || 0;
    document.body.style.paddingTop = `${base + HEIGHT}px`;
    return () => {
      document.body.style.paddingTop = prev;
    };
  }, [activeOrg]);

  if (!activeOrg) return null;

  const onLeave = () => {
    leave();
    navigate("/user");
  };

  return (
    <div
      role="status"
      aria-label="Supportläge"
      style={{
        position: "fixed",
        top,
        left: 0,
        right: 0,
        height: HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: "#f59e0b",
        color: "#1f1300",
        fontWeight: 600,
        fontSize: 14,
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        zIndex: 2147483646,
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        padding: "0 12px",
      }}
    >
      <span>
        Du arbetar i <strong>{activeOrg.username || "okänd organisation"}</strong>
        {activeOrg.email ? ` (${activeOrg.email})` : ""} — ändringar sparas på kundens konto
      </span>
      <button
        type="button"
        onClick={onLeave}
        style={{
          background: "#1f1300",
          color: "#fff",
          border: "none",
          borderRadius: 4,
          padding: "4px 12px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Lämna
      </button>
    </div>
  );
}
